// POST

import axios from 'axios';
import { FieldCollectionType } from '../types/field-collection-type.enum';
import { CreateFieldCollectionInput } from '../types/create-field-collection-input.type';

// /ewosapi/v2/fieldregistration/site/{globalSiteId}/fieldcollection/{fieldCollectionType}
export const postFieldCollectionByType = async (
  globalSiteId: string,
  fieldCollectionType: FieldCollectionType,
  request: CreateFieldCollectionInput
): Promise<number> => {
  const res = await axios.post<number>(
    `/ewosapi/v2/fieldregistration/site/${globalSiteId}/fieldcollection/${fieldCollectionType}`,
    request
  );
  return res.data;
};
